import { render, staticRenderFns } from "./quotationDescriptionsList.vue?vue&type=template&id=0fb6e127&scoped=true&"
import script from "./quotationDescriptionsList.vue?vue&type=script&lang=js&"
export * from "./quotationDescriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./quotationDescriptionsList.vue?vue&type=style&index=0&id=0fb6e127&lang=scss&scoped=true&"
import style1 from "./quotationDescriptionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6e127",
  null
  
)

export default component.exports